//react-bootstrap-date-picker
export const daylabels=['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];
export const monthlabels=['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'];


//configurations
export const useMock = process.env.REACT_APP_REACT_ENV === "mock";

export const mock=true